<script>
  import ClickOut from '../../../../../../utils/directives/clickout'

  export default{
    data () {
      return {
        open: false
      }
    },
    computed: {},
    mounted () {
      this.popupItem = this.$el
    },
    methods: {
      toggle () {
        this.open = !this.open
      },
      hide () {
        this.open = false
      },
      clicked: function (e) {
        console.log('prevented!')
        e.preventDefault()
      }
    },
    directives: {ClickOut}
  }
</script>

<template>
  <li :class="{ active: open }">
    <a v-click-out="hide" @click="toggle" class="auto">
      <span class="pull-right text-muted">
      <i class="fa fa-fw fa-angle-right text"></i>
      <i class="fa fa-fw fa-angle-down text-active"></i>
      </span>
      <!-- <i class="icon-screen-desktop icon "></i> -->
      <span>Operadora de Reboques</span>
    </a>
    <ul class="nav nav-sub dk">
      <li class="nav-sub-header"><a><span class="text-muted teste">Polícia Civil</span></a></li>
      <!--<li><a><span>Configurações</span></a></li>-->
      <li>
        <router-link :to="{ name: 'policiacivil.processo.operadora-reboque' }">
          <span>Operadora de Reboques</span>
        </router-link>
      </li>
    </ul>
  </li>
</template>



// WEBPACK FOOTER //
// OperadoraReboque.vue?e075f856